var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroFearIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_941_2053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9024 15.7714C23.8079 15.4051 21.007 14.0812 18.8039 12.1042C17.6894 12.3789 16.6556 12.8579 15.7441 13.499",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5073 24.5745C15.8604 26.7354 18.2625 28.1724 21.0001 28.1724C23.7351 28.1724 26.1351 26.7381 27.4889 24.5807",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8969 12.4134C29.066 8.2593 25.3984 5.12939 20.9998 5.12939C16.6154 5.12939 12.9573 8.23904 12.1108 12.3732",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3775 27.8149C17.3775 29.2254 16.35 30.4255 14.9565 30.6431L12.1152 31.0864",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6226 27.8149C24.6226 29.2254 25.65 30.4255 27.0435 30.6431L29.8796 31.0856",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9581 30.2366C24.7387 31.5952 22.969 32.4499 20.9998 32.4499C19.0306 32.4499 17.2609 31.5953 16.0415 30.2367",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0991 19.8091L23.3218 19.4609",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9009 19.8091L18.6782 19.4609",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2545 32.1866L40.5888 34.5135C41.8851 36.7741 40.9705 39.6598 38.6088 40.7611C36.247 41.8624 33.4486 40.7081 32.5501 38.262L26.9116 22.9112L32.4537 20.3269L35.5818 25.7821",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3981 20.8192L31.793 16.3056C31.8978 15.1074 31.4544 13.9261 30.587 13.0929L29.618 12.1621C28.645 11.2274 27.0431 11.5141 26.4547 12.7284C26.2172 13.2185 26.1913 13.7847 26.3832 14.2944L27.4237 17.0579L27.2573 18.9604C27.152 20.1636 27.3513 21.3739 27.837 22.4798L31.3981 20.8192Z",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39124 40.7611C5.75301 41.8624 8.55142 40.7081 9.44991 38.262L15.0884 22.9112L9.5463 20.3269L1.41126 34.5136C0.114917 36.7741 1.02948 39.6599 3.39124 40.7611Z",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6019 20.8192L10.207 16.3056C10.1022 15.1074 10.5457 13.9261 11.4131 13.0929L12.382 12.1621C13.3551 11.2274 14.957 11.5141 15.5454 12.7284C15.7829 13.2185 15.8087 13.7847 15.6168 14.2944L14.5764 17.0579L14.7428 18.9604C14.848 20.1636 14.6487 21.3739 14.1631 22.4798L10.6019 20.8192Z",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3055 23.5617C21.5842 22.8404 20.4147 22.8404 19.6934 23.5617",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1795 8.6958L37.1091 10.6347L39.6765 12.117L35.4561 14.52",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4564 0.820312L32.3999 4.1347L35.3345 4.55503L32.3115 8.3562",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.820312 8.6958L4.89079 10.6347L2.32337 12.117L6.5438 14.52",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54395 0.820312L9.60051 4.1347L6.66584 4.55503L9.68886 8.3562",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19092 41.179H36.8092",
    stroke: "#0097A9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_941_2053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroFearIc);
export default __webpack_public_path__ + "static/media/hero-fear-ic.078efde111d91f78cb510f05daca9eac.svg";
export { ForwardRef as ReactComponent };